<template>
  <div id="app" :class="{ desktop: device === 'desktop' }">

    <div id="title" class="title gradient text-center">

      <div v-if="device === 'desktop'">
        <div style="display: inline-block; background: #ffffff; border-radius: 6px; overflow: hidden; box-shadow: rgba(0,0,0, 0.5) 0px 3px 15px; border: 1px solid purple;">
          <div>
            <a v-if="settings.program && settings.program.banner_url" :href="settings.program.banner_url" target="_blank">
              <img src="@/assets/img/final.png" height="210" width="720" />
            </a>
            <img v-else src="@/assets/img/final.png" height="210" width="720"/>
          </div>
          <!-- <div>
            <h2 style="padding: 0.5rem 2rem">Programme Overview</h2>
          </div> -->
        </div>
      </div>

      <div v-else>
        <div style="display: inline-block; background: #ffffff; border-radius: 6px; overflow: hidden; box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 8px;">
          <div>
            <a v-if="settings.program && settings.program.banner_url" :href="settings.program.banner_url" target="_blank">
              <img src="@/assets/img/logo.png" height="60" />
            </a>
            <img v-else src="@/assets/img/logo.png" height="60" />
          </div>
          <!-- <div>
            <h4 style="padding: 0.25rem 1rem">Programme Overview</h4>
          </div> -->
        </div>
      </div>

    </div>

    <div class="menu">

      <div v-if="progress" class="program-progress"></div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-8" style="padding-left: 7px; padding-right: 7px;">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text toggle" @click="setSidebar(!sidebar)">
                  <font-awesome-icon :icon="['fas', 'bars']" />
                </span>
              </div>
              <input type="text" class="form-control" :placeholder="_.search_the_program" v-model="search" @keydown.enter.prevent="searchProgram()">
              <div class="input-group-append" @click="searchProgram()">
                <span class="input-group-text search">
                  <font-awesome-icon :icon="['fas', 'search']" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="body" :class="device">
      <div class="wrapper">
        <div class="menu" :style="{ 'margin-left': sidebar ? 0 : -310 + 'px' }">
          <div>

            <div class="head">
              <div class="main">

                <b-nav class="switch" v-if="/^\/program/i.test($route.path)">

                  <li></li>

                  <b-nav-item 
                    :to="'/program/' + ($route.params.key || 1) + '/horizontal'" 
                    class="horizontal"
                    :class="{ 'active': $route.path.match(new RegExp('horizontal$', 'i')) }">
                    <span><font-awesome-icon :icon="['fas', 'grip-horizontal']" /></span>
                  </b-nav-item>

                  <b-nav-item 
                    :to="'/program/' + ($route.params.key || 1) + '/vertical'" 
                    class="vertical"
                    :class="{ 'active': $route.path.match(new RegExp('vertical$', 'i')) }">
                    <span><font-awesome-icon :icon="['fas', 'grip-vertical']" /></span>
                  </b-nav-item>

                  <li v-if="program === 'horizontal'" class="horizontal_submenu">
                    <span><font-awesome-icon :icon="['fas', 'arrows-alt-h']" /></span>
                    <ul>
                      <li 
                        v-for="(sval, skey) in sizes.horizontal.room" 
                        :key="skey"
                        :class="{ active: sval.size === size.horizontal.room }"
                        @click="setRoom(sval.size)">
                        {{ sval.label }}
                      </li>
                    </ul>
                    <span><font-awesome-icon :icon="['fas', 'arrows-alt-v']" /></span>
                    <ul>
                      <li 
                        v-for="(sval, skey) in sizes.horizontal.hour" 
                        :key="skey"
                        :class="{ active: sval.size === size.horizontal.hour }"
                        @click="setHour(sval.size)">
                        {{ sval.label }}
                      </li>
                    </ul>
                  </li>

                  <li v-if="program === 'vertical'" class="vertical_submenu">
                    <span><font-awesome-icon :icon="['fas', 'arrows-alt-h']" /></span>
                    <ul>
                      <li 
                        v-for="(sval, skey) in sizes.vertical.hour" 
                        :key="skey"
                        :class="{ active: sval.size === size.vertical.hour }"
                        @click="setHour(sval.size)">
                        {{ sval.label }}
                      </li>
                    </ul>
                    <span><font-awesome-icon :icon="['fas', 'arrows-alt-v']" /></span>
                    <ul>
                      <li 
                        v-for="(sval, skey) in sizes.vertical.room" 
                        :key="skey"
                        :class="{ active: sval.size === size.vertical.room }"
                        @click="setRoom(sval.size)">
                        {{ sval.label }}
                      </li>
                    </ul>
                  </li>

                </b-nav>

              </div>
            </div>

            <div class="body">

              <div v-if="_.length" class="navigation">

                <b-nav vertical>

                  <b-nav-item 
                    :to="'/program/' + day + '/' + program" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/program', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'calendar']" /></span>
                    {{ _.program }}
                  </b-nav-item>

                  <b-nav-item 
                    to="/sessions" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/sessions', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fas', 'bars']" /></span>
                    {{ _.sessions }}
                  </b-nav-item>

                  <b-nav-item 
                    to="/persons" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/persons', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'users']" /></span>
                    {{ _.chairs_and_speakers }}
                  </b-nav-item>
                  <b-nav-item 
                    to="/abstractspresenters" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/abstractspresenters', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'users']" /></span>&nbsp;Presenter
                  </b-nav-item>

                </b-nav>

              </div>

              <div v-if="_.length" class="navigation divider">

                <b-nav vertical>

                  <b-nav-item 
                    to="/favorites" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/favorites', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fas', 'star']" /></span>
                    {{ _.favorites }}
                  </b-nav-item>

                  <!-- <li v-if="settings && settings.program" class="nav-item">
                    <a href="#" class="nav-link" @click.prevent="downloadProgram()">
                      <span class="icon"><font-awesome-icon :icon="['fad', 'file-pdf']" /></span>
                      {{ _.program_pdf }}
                    </a>
                  </li> -->

                  <li v-if="settings && settings.program" class="nav-item">
                    <a class="nav-link" :href="'https://pdf-program.abstractserver.com/?congress=' + CONGRESS" target="_blank">
                      <span class="icon"><font-awesome-icon :icon="['fad', 'file-pdf']" /></span>
                      {{ _.program_pdf }}
                    </a>
                  </li>

                </b-nav>

              </div>

              <div v-if="settings && settings.program && settings.program.show_timezone === '1' && !equalOffset(settings.app.event_timezone) && _.length" class="navigation divider">
                <b-nav vertical>
                  <li class="nav-item" :class="{ active: timezone === 'event' }">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'clock']" /></span>
                    <span class="action" @click="setTimezone('event')">&nbsp;{{ _.event_times }} ({{ getTimezone(settings.app.event_timezone, settings.app.event_locale) }})</span>
                  </li>
                  <li class="nav-item" :class="{ active: timezone === 'local' }">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'clock']" /></span>
                    <span class="action" @click="setTimezone('local')">&nbsp;{{ _.local_times }} ({{ getTimezone(local_timezone) }})</span>
                  </li>
                </b-nav>
               </div>

              <div v-if="settings && settings.program && settings.program.show_timezone !== '1' && !equalOffset(settings.app.event_timezone) && _.length" class="navigation divider">
                <b-nav vertical>
                  <li class="nav-item" :class="{ active: timezone === 'event' }">
                    <span class="icon"><font-awesome-icon :icon="['fad', 'clock']" /></span>
                    <span>&nbsp;{{ _.event_times }} ({{ getTimezone(settings.app.event_timezone, settings.app.event_locale) }})</span>
                  </li>
                </b-nav>
              </div>

              <div v-if="_.length" class="navigation divider">

                <b-nav vertical>

                  <li v-if="key && user" class="nav-item user">
                    <span class="icon"><font-awesome-icon :icon="['fas', 'user']" /></span>
                    {{ user.firstName }} {{ user.lastName }}
                  </li>

                  <li v-if="!key" class="nav-item">
                    <a class="nav-link" :href="AUTH_SERVER_URL + 'application/' + AUTH_SERVER_FRONTEND_KEY">
                      <span class="icon"><font-awesome-icon :icon="['fad', 'sign-in-alt']" /></span>
                      {{ _.login }}
                    </a>
                  </li>

                  <li v-else class="nav-item">
                    <a class="nav-link" href="" @click.prevent="logoutUser()">
                      <span class="icon"><font-awesome-icon :icon="['fad', 'sign-out-alt']" /></span>
                      {{ _.logout }}
                    </a>
                  </li>

                  <b-nav-item 
                    to="/help" 
                    :class="{ 'active': $route.path.match(new RegExp('^\/help', 'i')) }"
                    @click="setSidebar((device === 'mobile') ? !sidebar : sidebar)">
                    <span class="icon"><font-awesome-icon :icon="['fas', 'question-circle']" /></span>
                    {{ _.help }}
                  </b-nav-item>

                </b-nav>

              </div>

              <div class="filter" v-if="options.session_group">
                <div class="button" v-b-toggle:collapse-groups>
                  <p>{{ _.session_groups }}</p>
                  <span v-if="filter.session_group.length" class="reset"  @click.stop="resetFilter('session_group')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-groups">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(gval, gkey) in options.session_group" 
                      :key="gkey" 
                      :class="{ active: filter.session_group.includes(gval.id) }"
                      @click.prevent="updateFilter({ group: 'session_group', id: gval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_group.includes(gval.id) ? 'check-square' : 'square']" /></span>
                      {{ gval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <div class="filter" v-if="options.session_type">
                <div class="button" v-b-toggle:collapse-types>
                  <p>{{ _.session_types }}</p>
                  <span v-if="filter.session_type.length" class="reset" @click.stop="resetFilter('session_type')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-types">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(tval, tkey) in options.session_type" 
                      :key="tkey"
                      :class="{ active: filter.session_type.includes(tval.id) }"
                      @click.prevent="updateFilter({ group: 'session_type', id: tval.id })">
                      <span :style="{ color: tval.value.background }"><font-awesome-icon :icon="['fas', filter.session_type.includes(tval.id) ? 'check-square' : 'square']" /></span>
                      {{ tval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <div class="filter" v-if="rooms">
                <div class="button" v-b-toggle:collapse-rooms>
                  <p>{{ _.rooms }}</p>
                  <span v-if="filter.room.length" class="reset" @click.stop="resetFilter('room')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-rooms">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(rval, rkey) in rooms" 
                      :key="rkey"
                      :class="{ active: filter.room.includes(rval.id) }"
                      @click.prevent="updateFilter({ group: 'room', id: rval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.room.includes(rval.id) ? 'check-square' : 'square']" /></span>
                      {{ rval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <div class="filter" v-if="options.session_highlight">
                <div class="button" v-b-toggle:collapse-highlights>
                  <p>Highlights</p>
                  <span v-if="filter.session_highlight.length" class="reset" @click.stop="resetFilter('session_highlight')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-highlights">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(hval, hkey) in options.session_highlight" 
                      :key="hkey"
                      :class="{ active: filter.session_highlight.includes(hval.id) }"
                      @click.prevent="updateFilter({ group: 'session_highlight', id: hval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_highlight.includes(hval.id) ? 'check-square' : 'square']" /></span>
                      {{ hval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div>

              <!-- <div class="filter" v-if="options.session_industry">
                <div class="button" v-b-toggle:collapse-industries>
                  <p>Industries</p>
                  <span v-if="filter.session_industry.length" class="reset" @click.stop="resetFilter('session_industry')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-industries">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(ival, ikey) in options.session_industry" 
                      :key="ikey"
                      :class="{ active: filter.session_industry.includes(ival.id) }"
                      @click.prevent="updateFilter({ group: 'session_industry', id: ival.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_industry.includes(ival.id) ? 'check-square' : 'square']" /></span>
                      {{ ival.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div> -->

              <!-- <div class="filter" v-if="options.session_theme">
                <div class="button" v-b-toggle:collapse-themes>
                  <p>Themes</p>
                  <span v-if="filter.session_theme.length" class="reset" @click.stop="resetFilter('session_theme')">Reset</span>
                  <span class="open"><font-awesome-icon :icon="['fas', 'sort-down']" /></span>
                  <span class="closed"><font-awesome-icon :icon="['fas', 'sort-up']" /></span>
                </div>
                <b-collapse class="items" id="collapse-themes">
                  <b-nav vertical>
                    <b-nav-item 
                      v-for="(tval, tkey) in options.session_theme" 
                      :key="tkey"
                      :class="{ active: filter.session_theme.includes(tval.id) }"
                      @click.prevent="updateFilter({ group: 'session_theme', id: tval.id })">
                      <span><font-awesome-icon :icon="['fas', filter.session_theme.includes(tval.id) ? 'check-square' : 'square']" /></span>
                      {{ tval.name }}
                    </b-nav-item>
                  </b-nav>
                </b-collapse>
              </div> -->

            </div>
          </div>
        </div>
        <div class="content" @click="closeSidebar()">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <div class="footer">
      <div style="margin-top:0px;margin-bottom:0px;margin-left:auto;margin-right:auto;width:240px;padding:12px 12px 7px 12px;text-align:center;">
        <a href="https://documedias.com/" target="_blank">
          <img src="@/assets/img/powered.svg" style="height:20px;">
        </a>
      </div>
    </div>

    <b-modal v-model="modal" id="modal" style="z-index: 13000" hide-header hide-footer>
      <div class="d-block text-center">
        <p>{{ _.login_account }}</p>
      </div>
      <div class="row">
        <div class="col text-center">
          <b-button class="btn-login mr-1" :href="AUTH_SERVER_URL + 'application/' + AUTH_SERVER_FRONTEND_KEY">
            <span><font-awesome-icon :icon="['fad', 'sign-in-alt']" /></span>
            {{ _.login }}
          </b-button>
          <b-button class="ml-1" @click="setModal(false)">
            <span><font-awesome-icon :icon="['fas', 'times']" /></span>
            {{ _.cancel }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import { CONGRESS, AUTH_SERVER_URL, AUTH_SERVER_FRONTEND_KEY } from '@/config'

export default {
  data() {
    return {
      CONGRESS: CONGRESS,
      AUTH_SERVER_URL: AUTH_SERVER_URL,
      AUTH_SERVER_FRONTEND_KEY: AUTH_SERVER_FRONTEND_KEY,
    }
  },
  computed: {
    ...mapGetters(['device', 'width', 'sidebar', 'days', 'day', 'program', 'sort', 'rooms', 'options', 'filter', 'timezone', 'local', 'modal', 'key', 'user']),
    ...mapGetters('schedule', ['size', 'sizes']),
    search: {
      get() {
        return this.$store.state.search;
      },
      set(value) {
        this.setSearch(value);
      }
    },
  },
  methods: {
    ...mapMutations(['setDevice', 'setSidebar', 'setProgramSort', 'setSearch', 'setResults', 'setTimezone']),
    ...mapActions(['initializeProgram', 'updateFilter', 'resetFilter', 'getResults']),
    searchProgram() {
      if (this.$store.state.search != '') {
        if (!this.$route.path.match(/^\/results/)) {
          this.setResults([]);
          this.$router.push('/results');
        }
        this.getResults();
      }
    },
    closeSidebar() {
      if (this.device === 'mobile') this.setSidebar(false);
    },
    setRoom(size) {
      this.size[this.program].room = size;
      this.$root.$emit(this.program);
    },
    setHour(size) {
      this.size[this.program].hour = size;
      this.$root.$emit(this.program);
    },
    setSort(sort) {
      if (this.sort !== sort) {
        this.setProgramSort(sort);
        this.$root.$emit(this.program);
      }
    },
    windowWidth() {
      if (window.innerWidth > 576) {
        if (this.device !== 'desktop') this.setSidebar(true);
        this.setDevice('desktop');
      } else {
        if (this.device !== 'mobile') this.setSidebar(false);
        this.setDevice('mobile');
      }
    },
    loginUser() {
      window.location = AUTH_SERVER_URL + 'application/' + AUTH_SERVER_FRONTEND_KEY;
    },
    logoutUser() {
      localStorage.removeItem('x-api-key');
      this.$store.state.key = null;
      this.$store.state.user = null;
      if (this.$route.path != '/program/1/horizontal') this.$router.push('/program/1/horizontal');
    },
    equalOffset(zone) {
      let equal = true;
      this.days.map(day => {
        let local_date = DateTime.fromSQL(day.date);
        local_date = local_date.setZone(this.local_timezone);
        let event_date = DateTime.fromSQL(day.date);
        event_date = event_date.setZone(zone);
        if (local_date.toFormat('Z') !== event_date.toFormat('Z')) equal = false;
      });
      return equal;
    },
    getTimezone(zone, locale) {
      const zones = this.days.reduce((carry, day) => {
        let date = DateTime.fromSQL(day.date);
        date = date.setZone(zone);
        date = date.setLocale(locale || navigator.language)
        const abbreviation = date.toFormat('ZZZZ');
        const offset = this.settings.app.event_timestandard + date.toFormat('Z');
        carry.push((/\d/.test(abbreviation)) ? offset : abbreviation + ' / ' + offset);
        return carry;
      }, []);
      return [...new Set(zones)].join(',');
    },
    async downloadProgram() {
      let report = await this.axios.get(this.settings.program.pdf, { responseType: 'blob' });
      this.setProgress(false);
      const href = window.URL.createObjectURL(new Blob([report.data]));
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'pdf-program.pdf');
      document.body.appendChild(link);
      link.click();
    },
  },
  created() {
    this.windowWidth();
    addEventListener('resize', this.windowWidth);
  },
  destroyed() {
    removeEventListener('resize', this.windowWidth);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/app';
#modal___BV_modal_outer_ {
  z-index: 13000 !important;
}
.btn-login {
  background: $conference-color !important;
}
</style>
